import { mapValues, omit } from "lodash"

import Firebase from "#classes/Firebase"
import { DOC_TYPES } from "#customTypes/composedTypes/firebaseTypes"
import {
  type StudentArtwork,
  type StudentConstructor,
} from "#customTypes/composedTypes/studentTypes"
import { type Uuid } from "#customTypes/globalTypes"

/**
 * Portfolio-scoped reset for a single student: removes Firestore portfolio doc,
 * deletes portfolio chat comments for that student, and strips portfolio linkage
 * from each artwork entry (URLs and other fields preserved).
 */
export const clearPortfolioTestDataForStudent = async (
  student: StudentConstructor
): Promise<{ artwork: Record<Uuid, StudentArtwork> } | null> => {
  const fb = Firebase.getInstance()
  const studentId = student.id

  if (await fb.checkIfDocExists(DOC_TYPES.PORTFOLIOS, studentId)) {
    await fb.deleteDocument(DOC_TYPES.PORTFOLIOS, studentId)
  }

  await fb.deleteDocumentsByFieldEquals(
    DOC_TYPES.PORTFOLIO_COMMENTS,
    "studentId",
    studentId
  )

  const artwork = student.artwork
  if (!artwork || Object.keys(artwork).length === 0) {
    return null
  }

  const cleanedArtwork: Record<Uuid, StudentArtwork> = mapValues(
    artwork,
    (piece) =>
      omit({ ...piece, inPortfolio: false }, ["projectId", "sortIndex"])
  )

  return { artwork: cleanedArtwork }
}
